export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"LARGE je platforma Akademie výtvarných umění v Praze zaměřená na umělecký výzkum, interdisciplinární spolupráci a postgraduální vzdělávání."},{"name":"keywords","content":"LARGE, AVU, umělecký výzkum, postgraduální studium, umění, Praha, výtvarné umění, interdisciplinarita, performativní výzkum"},{"name":"author","content":"Akademie výtvarných umění v Praze"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"property":"og:title","content":"LARGE – Laboratoř pro umění, výzkum a postgraduální vzdělávání"},{"property":"og:description","content":"Platforma AVU pro umělecký výzkum a vzdělávání – konference, performativní akce a interdisciplinární spolupráce."},{"property":"og:url","content":"https://large.avu.cz/"},{"property":"og:type","content":"website"},{"property":"og:image","content":"/large_og.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"LARGE – Laboratoř pro umění, výzkum a postgraduální vzdělávání"},{"name":"twitter:description","content":"Iniciativa AVU zaměřená na výzkum v umění a jeho performativní prezentaci."},{"name":"twitter:image","content":"/large_og.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon/favicon-96x96.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/favicon/web-app-manifest-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/favicon/web-app-manifest-512x512.png"}],"style":[],"script":[],"noscript":[],"title":"LARGE – Laboratoř pro umění, výzkum a postgraduální vzdělávání | AVU Praha"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true